import { debounce } from 'lodash'
import EventBus from './_event-bus'

const DEBOUNCE_THRESHOLD = 200

window.addEventListener('orientationchange', () => EventBus.$emit('resize', window.innerWidth))
window.addEventListener(
  'resize',
  debounce(() => {
    EventBus.$emit('resize', window.innerWidth)
  }, DEBOUNCE_THRESHOLD)
)
